import { useIntl } from 'react-intl';

import DepartmentSelect from '~/components/Shared/DepartmentSelect/DepartmentSelect';
import { useAppConfigContext } from '~/contexts/AppConfig';
import { FormField } from '~/eds/src/components/FormField/FormField';
import { PilotId } from '~/eds/src/types/PilotId';
import { Nullable } from '~/types/Nullable';

import { DepartmentCustomSettings } from '../types/fields';
import { WorkflowQuestionFormField } from './types';

export const DepartmentWorkflowQuestion = ({
  question,
  onChange,
  ...rest
}: WorkflowQuestionFormField<Nullable<PilotId[]>>) => {
  const intl = useIntl();
  const { isPanelEnlarged } = useAppConfigContext();
  const {
    field: { customSettings, value },
  } = question;
  const {
    departments,
    rule,
    allow_multiple: allowMultiple,
  } = customSettings as DepartmentCustomSettings;

  return (
    <FormField
      {...rest}
      input={DepartmentSelect}
      placeholder={
        allowMultiple
          ? intl.formatMessage({
              id: 'DepartmentWorkflowQuestion.selectMultipleUsersPlaceholder',
              defaultMessage: 'Specify one or more departments...',
              description:
                'Placeholder for selecting multiple users in an intake form question',
            })
          : intl.formatMessage({
              id: 'DepartmentWorkflowQuestion.selectSingleUserPlaceholder',
              defaultMessage: 'Specify a department...',
              description:
                'Placeholder for selecting a single user in an intake form question',
            })
      }
      value={value.value}
      onChange={(value) => onChange(value, 'value')}
      inputProps={{
        enablePortal: true,
        notAvailableDepartments:
          rule === 'all_except' ? departments : undefined,
        specificDepartments: rule === 'specific' ? departments : undefined,
        isMulti: allowMultiple,
        width: isPanelEnlarged ? 'l' : '100%',
      }}
    />
  );
};
